import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'
import { VerificationMethodEnum } from 'libs/gb-front/shared/models/shared.models'

/**
 * Interface for the 'Authentication' state
 */
export interface UserEntity {
  uuid?: string
  first_name?: string
  last_name?: string
  email?: string
  phone_number?: string
  is_staff?: boolean
}

export interface AuthenticationEntity {
  token?: string
  refresh_token?: string
  profile: ProfileEntity
}

export interface RegisterPayload {
  auction?: string
  identity: string
  invite_first_name: string
  invite_last_name: string
  password: string
  redirect_url?: string | null
  grecaptcha_token?: string
  code_only?: boolean
}

export interface RegisterResponse {
  uuid: string
  auction: string
  display_anonymous: boolean
  invite_first_name: string
  invite_last_name: string
  redirect_url?: string | null
}

export interface RegisterVolunteerPayload extends RegisterPayload {
  delegate?: string
}

export interface VerificationPayload {
  identity?: string
  verification_code?: string
  verification_token?: string
}

export interface verificationResponse {
  additional_info_required: boolean
  auction: string
  credit_card_required: string
  profile: ProfileEntity
  redirect_url: string | null
  token: string
  user: UserEntity
}

export interface ResendSmsVerificationResponse {
  detail: string
}

export interface AccountDetailsFormConfig {
  allFieldsOptional?: boolean
  showPreferredContact?: boolean
  showCancel: boolean
  showSkip: boolean
  submitTranslateKey: string
  nameEditable: boolean
}

export interface forgotPasswordPayload {
  grecaptcha_token: string
  phone_number?: string
  email?: string
}

export interface verifyForgotPasswordPayload {
  password: string
  token: string
  user: string
}

export interface VerifyForgotPasswordResponse {
  authentication: AuthenticationEntity
}

export interface ChangePasswordPayload {
  old_password: string
  new_password: string
}

export interface volunteerLoginPayload {
  passcode: string
  grecaptcha_token: string
}

export interface ShortUrl {
  actual_url: string
  token: string
  refresh_token?: string
}

export interface AuthErrors {
  verify?: string
}

export interface SendVerificationPayload {
  phone_number?: string | null
  email?: string | null
  code_only?: boolean
  verification_type?: VerificationTypeEnum
}

export interface RegisterExtras {
  verification_method?: VerificationMethodEnum
}

export interface VerifyExtras {
  code_only?: boolean // omits "Verify" button in email if true
}

export enum PermissionEnum {
  Guest = 'guest',
  Volunteer = 'volunteer',
}

export enum IdentityTypeEnum {
  Mobile = 'mobile',
  Email = 'email',
  Both = 'both',
}

export enum SocialLoginTypeEnum {
  Google = 'google-oauth2',
  Facebook = 'facebook',
}

export enum AuthDialogResultEnum {
  RegisterSuccess = 'registerSuccess',
  LoginSuccess = 'loginSuccess',
}

export enum VerificationTypeEnum {
  Email = 'email',
  PhoneNumber = 'phone_number',
}
